import { MobilePerformanceConfig } from './types';

/**
 * Computes mobile-appropriate configuration values by
 * clamping/reducing desktop defaults for mobile devices.
 */
export class PerformanceScaler {
  /**
   * Returns a performance configuration based on device type.
   * Desktop gets full quality; mobile gets reduced values for smoother performance.
   */
  static getConfig(isMobile: boolean): MobilePerformanceConfig {
    if (isMobile) {
      return {
        maxParticleCount: 2000,
        orbitLineSegments: 128,
        fieldLineSegmentBudget: 2500,
        fieldLineSegmentsPerCurve: 32,
        sphereWidthSegments: 24,
        sphereHeightSegments: 16,
        antialias: false,
        maxPixelRatio: 2.0,
      };
    }

    return {
      maxParticleCount: 10000,
      orbitLineSegments: 256,
      fieldLineSegmentBudget: 5000,
      fieldLineSegmentsPerCurve: 64,
      sphereWidthSegments: 32,
      sphereHeightSegments: 32,
      antialias: true,
      maxPixelRatio: Infinity,
    };
  }

  /**
   * Clamps a device pixel ratio to a maximum value.
   * Ratios <= 1.0 are preserved unchanged.
   */
  static clampPixelRatio(devicePixelRatio: number, maxRatio: number): number {
    if (devicePixelRatio <= 1.0) {
      return devicePixelRatio;
    }
    return Math.min(devicePixelRatio, maxRatio);
  }
}
